<template>
  <div class="container">
    <p class="mb-0"> <b>En caso de producirse un error al asignar cargos y sedes:</b> intente crear el usuario (usando el boton de abajo) y luego vuelva asignar los cargos a esta persona, con eso el problema ya estaria solucionado. </p>
    <button type="button" :disabled="buscando || !existe_in_talento" class="btn btn-sm btn-success white--text" @click="crearu()" title="Convierte a esta persona como usuario del sistema"> Crear Usuario Nuevo </button>
    <p class="text-center text-primary"> {{msgg}} </p>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  data(){
    return{
      persona: {},
      cargando:  false,
      buscando:  false,
      existe_in_talento: false,
      msgg:'',
    }
  },
  components:{},
  methods:{

    async buscarTalento(){
      // window.console.log( "CREAAAAA",this.persona )
      const url = process.env.VUE_APP_RRHH+'/empleados/validar?nro_ci='+this.persona.num_doc
      const tokenStatic = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaXN0ZW1hIjoic2lzdGVtYV9wb3J0YWwiLCJpYXQiOjE3Mjg1MDgxNTAsImV4cCI6MzE3MjcyOTUwNTUwfQ.mo9Y8O-B4-AIoMt2rHKqVUZrDy_Z5oBZAn1VrrMLFzg';
      const h = {
          method: 'GET',
          headers: {
              'Authorization': `Bearer ${tokenStatic}`,
              'Content-Type': 'application/json'
          }
      }
      this.existe_in_talento = false;
      this.buscando = true;
      const res = await fetch(url,h).then((response) => response.json()).then((result) =>  (result)).catch((error) =>  (error));
      let compatible = res.datos.compatibilidad.isCompatible;
      let cvigente = res.vigente && compatible? 'success': 'red';
      let mensaje = res.message? res.message: res.mensaje;
      this.existe_in_talento = res.vigente && compatible? true: false;

      this.$root.$notify.show(mensaje, { color: cvigente, x: 'right' });
/*
      if(res.datos){
          window.console.log('talentoooo', res.datos);
      }*/
      if(!this.existe_in_talento){
        this.msgg = mensaje;
        if(!compatible){
          this.msgg += 'NO COMPATIBLE'
        }
      }

      this.buscando = false;
    },

    crearu(){
      if( this.cargando ) return;
      if(!this.existe_in_talento) {
        window.alert("Primero debe estar registrado en el sistema de talento humano");
        return;
      }
      var cgs = JSON.parse( window.sessionStorage.CARGOS_ASIG );
      if( !cgs.length ){
        window.alert( "ERROR: Seleccione al menos un cargo para asignar" );
        return;
      }else{
        cgs = cgs[0];
      }
      this.cargando = true;
      this.msgg = 'Creando usuario....';
      // window.console.log( "CREAAAAA",this.persona )

      var vue = this;
      var sql = gql`
      mutation{
        createUsuario(input:{
          id:${this.persona.id},
          login:"${this.persona.usuario_moodle}",
          clave:"${this.persona.clave_moodle}",
          idsede:${cgs.idsede},
          idcargo:${cgs.idcargo}
        }){ok,errors{message}}
      }`;
      //window.console.log( "+++++++++++++++++++++",sql )
      this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        var us = data.data.createUsuario;
        window.console.log( "TOUSER: ",us );
        if( us.ok ) this.msgg = 'Usuario Creado, ahora debe asignar los cargos de este usuario.'
        else{
          this.msgg = 'No se pudo crear el usuario.'
        }
        this.cargando = false;
        
      }).catch((error) => {
        window.console.error(error);
        vue.cargando = false;
        vue.msgg = error;
      })
    },
  },
  mounted(){
    var est = JSON.parse(sessionStorage.getItem( 'xestudiante' ))
    this.persona = est;
    this.buscarTalento();
  },
}
</script>